import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";

//COMPONENTS
import AdminWeeksHolidays from "./files/weekSystemHolidays";
import CollisionBookings from "./files/collisionBookings";

function PodRouter() {
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        setIsLoaded(true);
    });

    return (
        <div style={{ height: "100%" }}>
            {isLoaded && (
                <div style={{ height: "100%" }}>
                    <Routes>
                        <Route path="/" element={<AdminWeeksHolidays />} />
                        <Route path="/collisionBookings" element={<CollisionBookings />} />
                    </Routes>
                </div>
            )}
        </div>
    );
}

export default PodRouter;
